<script setup lang="ts">
import { sectionAnchorMap, useSectionsStore, type SectionName } from '@/stores/sections';
import TextBlock from './TextBlock/TextBlock.vue';

const { loading = 'eager', name } = defineProps<{
  name: SectionName;
  label?: string;
  headline?: string;
  loading?: 'lazy' | 'eager';
}>();

const sectionsStore = useSectionsStore();

const { sectionRef } = sectionsStore.register(name, loading);
</script>

<template>
  <a v-if="sectionAnchorMap[name]" :id="sectionAnchorMap[name]" class="owpi-spa-anchor"></a>
  <article
    v-if="sectionsStore.visible[name]"
    :ref="sectionRef"
    :aria-label="label ?? name"
    :data-section="name"
    :data-loaded="sectionsStore.loaded[name]"
  >
    <TextBlock v-if="label && headline" :subtitle="label" :headline="headline" />
    <Suspense>
      <slot v-if="sectionsStore.loaded[name]"></slot>
      <slot v-else name="loading"></slot>

      <template #fallback>
        <slot name="loading"></slot>
      </template>
    </Suspense>
  </article>
</template>

<style lang="scss">
.owpi-spa-anchor {
  // offset for fixed header
  scroll-margin-top: var(--wb-spacing-m);
}
</style>
